module.exports = __webpack_public_path__ + "img/swords-laser.c8be072a.svg";